<!-- <p>sdg-certificate works!</p> -->
<section class="sdg-certificate">
  <h1 class="sdg-certificate__title">{{ label }}</h1>
  <ol class="sdg-certificate__list">
    <li class="sdg-certificate__list__item" *ngFor="let item of totalRange; let i = index" [class.set--active]="i < level">
      <span></span>
    </li>
  </ol>

  <!-- <input type="range" min="0" [max]="total.length" [value]="level" step="1" class="n n2" disabled /> -->
  <strong class="sdg-certificate__value">{{ value }}</strong>
</section>
